export default "__VITE_ASSET__Dbl$zR7V__"